import React from 'react';
import { IconButton_IconSizes, Row, Text } from '@ydistri/ds';
import EntityListSourceTypeIcon from './EntityListSourceTypeIcon';
import ArchivedEntityListIcon from './ArchivedEntityListIcon';
import DataDeletedEntityListIcon, { DataDeletedOf } from './DataDeletedEntityListIcon';
import { EntityListSourceType } from '@ydistri/api-sdk';
import { EntityListDescriptionInfoIconTooltip } from '../../../screens/ProjectAdministration/common/EntityListDescription';

interface EntityListTitleProps {
  title: string;
  sourceType: EntityListSourceType;
  archived?: boolean;
  /** Whose data were deleted, when they were; the icon replaces the archived one. */
  dataDeleted?: DataDeletedOf;
  description?: string;
  entityListId?: number;
  entityListVersionId?: number;
  customerEntityListId?: string | null;
}

/**
 * Component displaying the title of an entity list along with its source type icon,
 * archived status, and an optional description tooltip.
 * @param title Title of the entity list
 * @param sourceType Source type of the entity list (user, integration, computed)
 * @param archived Whether the entity list is archived
 * @param dataDeleted Whose data were deleted, the list's or the shown version's
 * @param description Optional description of the entity list
 * @param entityListId
 * @param customerEntityListId
 * @param entityListVersionId
 */
const EntityListTitle: React.FC<EntityListTitleProps> = ({
  title,
  sourceType,
  archived = false,
  dataDeleted,
  description,
  entityListId,
  customerEntityListId,
  entityListVersionId,
}) => {
  return (
    <Row $gap="1rem" $alignItems="center">
      <EntityListSourceTypeIcon
        entityListSourceType={sourceType}
        size={IconButton_IconSizes.xSmall}
        entityListId={entityListId}
        customerEntityListId={customerEntityListId}
        entityListVersionId={entityListVersionId}
      />
      <Text>{title}</Text>
      {dataDeleted ? (
        <DataDeletedEntityListIcon of={dataDeleted} />
      ) : (
        archived && <ArchivedEntityListIcon />
      )}
      {description && <EntityListDescriptionInfoIconTooltip description={description} />}
    </Row>
  );
};

export default EntityListTitle;
